module.exports = __webpack_public_path__ + "img/caret-down-dark.5b19ad59.svg";